import { render } from "./App.vue?vue&type=template&id=add69e9c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=add69e9c&lang=css"
script.render = render

export default script